import type { ComponentProps, PropsWithChildren } from 'react'
import React from 'react'
import _FloatingDropdown from '../_FloatingDropdown'
import DropdownSheetSheet from './DropdownSheetSheet'

type InheritedSheetProps = Pick<ComponentProps<typeof DropdownSheetSheet>, 'size' | 'height'>
type InheritedFloatingDropdownProps = Pick<ComponentProps<typeof _FloatingDropdown>, 'placement' | 'anchorRef' | 'boundaryRef' | 'triggerRef' | 'open' | 'portaled' | 'onClose' | 'id' | 'crossAxisShift' | 'autoHeight' | 'anchorOffset' | 'keepOpenOnModalClick'>

interface Props extends PropsWithChildren, Utils.PropsWithDataAttributes, InheritedSheetProps, InheritedFloatingDropdownProps {
  ref?: React.Ref<HTMLDivElement>
}

function DropdownSheetBase(props: Props) {
  const {
    children,
    size,
    height,
    placement,
    open,
    anchorRef,
    boundaryRef,
    triggerRef,
    id,
    onClose,
    crossAxisShift,
    autoHeight,
    portaled,
    anchorOffset,
    ref,
    ...rest
  } = props

  return <_FloatingDropdown
    {...rest}
    ref={ref}
    width={size === 'fill-anchor' ? 'match-anchor' : 'auto'}
    placement={placement}
    anchorRef={anchorRef}
    boundaryRef={boundaryRef}
    triggerRef={triggerRef}
    open={open}
    disableFlip
    id={id}
    onClose={onClose}
    crossAxisShift={crossAxisShift}
    autoHeight={autoHeight}
    portaled={portaled}
    anchorOffset={anchorOffset}
  >
    <DropdownSheetSheet size={size} height={height} autoHeight={autoHeight}>
      {children}
    </DropdownSheetSheet>
  </_FloatingDropdown>
}

export default DropdownSheetBase
